import { createFileRoute } from '@tanstack/react-router';
import { HeroSignupForm } from '@/features/consumer/home/hero-signup-form';

export const Route = createFileRoute('/embed/signup')({
  component: EmbedSignupPage,
  head: () => ({
    meta: [
      { title: 'Itria Home — Start booking' },
      { name: 'robots', content: 'noindex, nofollow' },
    ],
  }),
});

function EmbedSignupPage() {
  return (
    <div className="min-h-0 bg-[#232323] p-4 flex items-start justify-center">
      <div className="w-full max-w-[420px]">
        <HeroSignupForm variant="embed" />
      </div>
    </div>
  );
}
